import { ReactNode, useEffect, useRef, useState } from "react";
import {
  IPageDataModel,
  IPageLayoutResponseModel,
  IPageResponseModel,
  TOptionalType,
} from "../core/models";
import { getPageData } from "../core/api.service";
import Header from "../components/Header/Header";
import SwiperHighlights from "../components/Swipers/SwiperHighlights/SwiperHighlights";
import CategoryCardList from "../components/Lists/CategoryCardList/CategoryCardList";
import { useLocation, useNavigate } from "react-router";
import TitleWithDescription from "../components/TitleWithDescription/TitleWithDescription";
import SwiperProduct from "../components/Swipers/SwiperProduct/SwiperProduct";
import ListCard from "../components/Lists/ListCard/ListCard";
import Table from "../components/Table/Table";
import Banner from "../components/Banner/Banner";
import ArticleMain from "../components/ArticleMain/ArticleMain";
import BannerSecondary from "../components/BannerSecondary/BannerSecondary";
import DateContent from "../components/DateContent/DateContent";
import Podcast from "../components/Podcast/Podcast";
import BannerMultimedya from "../components/BannerMultimedya/BannerMultimedya";
import ActionFooter from "../components/ActionFooter/ActionFooter";
import ArticleSecondary from "../components/ArticleSecondary/ArticleSecondary";
import ArticleBulten from "../components/ArticleBulten/ArticleBulten";

const Home = () => {
  const location = useLocation();

  const [pageResponse, setPageResponse] =
    useState<TOptionalType<IPageResponseModel>>();

  const previousPath = useRef<string | null>(null);
  const isInitialRender = useRef(true);

  const navigate = useNavigate();

  const handleBack = () => {
    if (previousPath.current) {
      navigate(-1);
    } else {
      window.location.href = "app://closeWebView";
    }
  };

  useEffect(() => {
    if (isInitialRender.current) {
      // İlk render'ı atla
      isInitialRender.current = false;
      return;
    }

    // İlk render sonrası güncelleme yap
    previousPath.current = location.pathname === "/" ? null : location.pathname;
  }, [location]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    getPageData(location.pathname).then((response: IPageResponseModel) => {
      setPageResponse(response);
    });
  }, [location.pathname]);

  return (
    <div className="page">
      {pageResponse &&
        pageResponse?.data?.map(
          (layout: IPageLayoutResponseModel, index: number) => {
            return (
              <div className="page-wrapper" key={index}>
                {layout.pageComponents?.map(
                  (component: IPageDataModel, index: number): ReactNode => {
                    if (component.componentname === "header_search") {
                      return (
                        <Header
                          props={component.data}
                          key={index}
                          pageId={component.data.search_type}
                          showBack={!!previousPath.current}
                          handleBack={handleBack}
                        ></Header>
                      );
                    }

                    if (component.componentname === "comp_spotlist") {
                      return (
                        <SwiperHighlights
                          props={component.data}
                          key={index}
                        ></SwiperHighlights>
                      );
                    }

                    if (component.componentname === "navigation_boxes") {
                      return (
                        <CategoryCardList
                          props={component.data}
                          key={index}
                        ></CategoryCardList>
                      );
                    }

                    if (component.componentname === "content_list") {
                      return (
                        <ListCard props={component.data} key={index}></ListCard>
                      );
                    }

                    if (component.componentname === "text_content") {
                      return (
                        <TitleWithDescription
                          props={component.data}
                          key={index}
                        ></TitleWithDescription>
                      );
                    }

                    if (component.componentname === "mini_list") {
                      return (
                        <SwiperProduct
                          props={component.data}
                          key={index}
                        ></SwiperProduct>
                      );
                    }

                    if (component.componentname === "market_data") {
                      return <Table props={component.data} key={index}></Table>;
                    }

                    if (component.componentname === "page_banner2") {
                      return (
                        <Banner
                          content={component.data}
                          key={index}
                          onlyDocument={false}
                        ></Banner>
                      );
                    }

                    if (
                      component.componentname === "list_detail" &&
                      component.data.document_url &&
                      component.data.document_url !== ""
                    ) {
                      return (
                        <Banner
                          content={component.data}
                          onlyDocument={true}
                          key={index}
                        ></Banner>
                      );
                    }

                    if (component.componentname === "site_content") {
                      return (
                        <ArticleMain
                          content={component.data}
                          key={index}
                        ></ArticleMain>
                      );
                    }

                    if (component.componentname === "news_detail") {
                      return (
                        <>
                          <ArticleSecondary
                            content={component.data}
                            key={index}
                          ></ArticleSecondary>
                        </>
                      );
                    }

                    if (component.componentname === "bulten_detail") {
                      return (
                        <>
                          <ArticleBulten
                            content={component.data}
                            key={index}
                          ></ArticleBulten>
                        </>
                      );
                    }

                    if (component.componentname === "page_banner") {
                      return (
                        <BannerSecondary
                          content={component.data}
                          key={index}
                        ></BannerSecondary>
                      );
                    }

                    if (component.componentname === "date_content") {
                      return (
                        <DateContent
                          content={component.data}
                          key={index}
                        ></DateContent>
                      );
                    }

                    if (component.componentname === "podcast_detail") {
                      return (
                        <Podcast content={component.data} key={index}></Podcast>
                      );
                    }

                    if (component.componentname === "multimedia_banner") {
                      return (
                        <BannerMultimedya
                          content={component.data}
                          key={index}
                        ></BannerMultimedya>
                      );
                    }

                    if (component.componentname === "page_share") {
                      return (
                        <ActionFooter
                          content={component.data}
                          key={index}
                        ></ActionFooter>
                      );
                    }

                    return;
                  }
                )}
              </div>
            );
          }
        )}
    </div>
  );
};

export default Home;
